import React, { Suspense } from "react";
import { Await, defer, useLoaderData } from "react-router-dom";
import SystemMailCampaignEditor from "../../components/SystemMailCampaign/SystemMailCampaignEditor";
import { getSystemMailCampaign } from "../../api/systemMailCampaignClient";
import { loadCustomerReceiverGroups } from "../Receiver/ReceiverManager";
import { getCustomerSystemMails } from "../../api/systemMailClient";
import { SystemMailCampaign } from "../../model/SystemMailCampaign";
import { ReceiverGroup } from "../../model/ReceiverGroup";
import { SystemMailWithoutBody } from "../../model/SystemMail";
import { CircularProgress } from "@mui/material";
import { json } from "react-router-dom";

const EditSystemMailCampaignPage: React.FC = () => {
    const { campaign, receiverGroups, systemMailTemplates } = useLoaderData() as {
        campaign: Promise<SystemMailCampaign>;
        receiverGroups: Promise<ReceiverGroup[]>;
        systemMailTemplates: Promise<SystemMailWithoutBody[]>;
    };

    return (
        <Suspense fallback={<CircularProgress />}>
            <Await resolve={Promise.all([campaign, receiverGroups, systemMailTemplates])}>
                {([campaignData, receiverGroupsData, systemMailTemplatesData]) => (
                    <SystemMailCampaignEditor
                        method="PUT"
                        campaign={campaignData}
                        receiverGroups={receiverGroupsData}
                        systemMailTemplates={systemMailTemplatesData}
                    />
                )}
            </Await>
        </Suspense>
    );
};

export default EditSystemMailCampaignPage;

async function loadCampaign(campaignId: string, customerId: string) {
    try {
        return await getSystemMailCampaign(campaignId, customerId);
    } catch {
        throw json({ message: "Could not fetch system mail campaign." }, { status: 500 });
    }
}

async function loadSystemMailTemplates(customerId: string) {
    return getCustomerSystemMails(customerId);
}

export async function loader({
    params,
}: {
    request: Request;
    params: { customerId: string; campaignId: string };
}) {
    const { customerId, campaignId } = params;
    return defer({
        campaign: loadCampaign(campaignId, customerId),
        receiverGroups: loadCustomerReceiverGroups(customerId),
        systemMailTemplates: loadSystemMailTemplates(customerId),
    });
}
